import { createComponentExtension } from '@backstage/core-plugin-api';
import { homePlugin } from '@backstage/plugin-home'; // Import ComponentParts
import {createCardExtension} from '@backstage/plugin-home-react';
import { ComponentType } from 'react';

export const QuickActionBar: ComponentType = homePlugin.provide(
  createComponentExtension({
    name: 'QuickActionBar',
    component: {
      lazy: () =>
        import('./components/QuickActionBar').then(m => m.QuickActionBar),
    },
  }),
);

export const Toolkit: ComponentType = homePlugin.provide(
  createComponentExtension({
    name: 'Toolkit',
    component: {
      lazy: () => import('./components/Toolkit').then(m => m.Toolkit),
    },
  }),
);

export const NotificationTableCard = homePlugin.provide(
  createCardExtension({
    name: 'NotificationTableCard',
    title: 'Incidents / Maintenances / Release updates',
    description: 'List notifications for Incidents, Maintenances and Updates',
    components: () => import('./components/NotificationTableCard'),
    layout: {
      height: { minRows: 5 },
      width: { minColumns: 6 },
    },
  }),
);

export const Banner: ComponentType = homePlugin.provide(
  createComponentExtension({
    name: 'Banner',
    component: {
      lazy: () => import('./components/Banner').then(m => m.Banner),
    },
  }),
);


